import * as React from "react";
const SVGComponent = ({ width = "15px", height = "15px", color = "var(--checkbox-bg)", ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={15} height={15} rx={7.5} fill={color} />
    <rect x={5} y={5} width={5} height={5} rx={2.5} fill="white" />
  </svg>
);
export default SVGComponent;